import { Action } from '@ngrx/store';
import { SideBarConfig } from '../reducers/side-bar-config';

export enum SideBarActionTypes {
  SetSideBarConfig = '[SideBar] Set SideBar Config',
  ShowSideBar = '[SideBar] Show SideBar',
  HideSideBar = '[SideBar] Hide SideBar',
  ToggleSideBar = '[SideBar] Toggle SideBar',
  AutoShowSideBar = '[SideBar] Auto Show SideBar',
}

export class AutoShowSideBar implements Action {
  readonly type = SideBarActionTypes.AutoShowSideBar;
}

export class ToggleSideBar implements Action {
  readonly type = SideBarActionTypes.ToggleSideBar;
}

export class ShowSideBar implements Action {
  readonly type = SideBarActionTypes.ShowSideBar;
}

export class HideSideBar implements Action {
  readonly type = SideBarActionTypes.HideSideBar;
}

export class SetSideBarConfig implements Action {
  readonly type = SideBarActionTypes.SetSideBarConfig;

  constructor(public config: Partial<SideBarConfig>) {}
}

export type SideBarActions =
  | SetSideBarConfig
  | HideSideBar
  | ShowSideBar
  | ToggleSideBar
  | AutoShowSideBar;
